import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';

export default Vue.component('disable-enable', {
  template: require('./template.html'),
  name: 'disable-enable',
  mixins: [guid],
  computed: {
    ...mapGetters(['currentUser', 'account']),
  },
  data() {
    return {
      loading: false,
      saveError: false,
      reason: '',
    };
  },
  props: ['toggle-modal', 'modal', 'opposite'],
  methods: {
    async saveUserStatus() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.loading = true;
          this.saveError = false;
          try {
            const status = this.currentUser.status;
            let value;
            if (status === 'active') {
              await this._SEND([{
                name: 'disableAccount',
                payload: {
                  reason: this.reason,
                },
              }]);
              value = 'disabled';
            } else if (status === 'disabled') {
              await this._SEND([{ name: 'enableAccount' }]);
              value = 'active';
            }
            this.$store.dispatch('setGlobalValue', {
              item: this.account,
              key: 'status',
              value,
            });
            this.$store.dispatch('setGlobalValue', {
              item: this.currentUser,
              key: 'status',
              value,
            });
            this.closeModal('disableEnable');
            this.$store.dispatch('addNotification', {
              type: 'success',
              id: this.guid(),
              message: `User successfully marked ${this.opposite}ed`,
            });
          } catch (e) {
            this.saveError = `${e.message || e}. This has been reported.`;
            await this._reportError({
              error: e,
              fn: 'saveUserStatus',
            });
          } finally {
            this.loading = false;
          }
        }
      });
    },
    closeModal(type) {
      this.$emit('toggle-modal', type, 'child');
    },
    formatErrors(arr) {
      return arr.join(' ');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/account/profile/disable-enable/index.js